module.exports = __webpack_public_path__ + "img/products.bd44244b.svg";